function isBoolean(value: unknown): value is boolean {
  return (
    (typeof value === 'string' && (value === 'true' || value === 'false')) ||
    typeof value === 'boolean' ||
    value instanceof Boolean
  );
}

function isStringBoolean(value: string): boolean {
  return value === 'true' || value === 'false' || value === '1' || value === '0' || value === 'on' || value === 'off';
}

function parseBoolean(value: unknown): boolean {
  if (typeof value === 'string') {
    return value === 'true' || value === '1' || value === 'on';
  }

  return Boolean(value);
}

export { isBoolean, isStringBoolean, parseBoolean };
